"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _numeral = _interopRequireDefault(require("numeral"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var propTypes = {
  className: _propTypes.default.string,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  value: _propTypes.default.number,
  placeholder: _propTypes.default.string,
  decimals: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  format: _propTypes.default.string,
  autoCorrect: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onEnter: _propTypes.default.func,
  onEscape: _propTypes.default.func
};
var defaultProps = {
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  decimals: 2,
  disabled: false,
  format: '0,0.00',
  autoCorrect: false
};
var keyCodes = {
  enter: 13,
  escape: 27,
  left: 37,
  up: 38,
  right: 39,
  down: 40
};
var Helper = {
  anyChanges: function anyChanges(properties, prevProps, props) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var property = _step.value;

        if (prevProps[property] !== props[property]) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  },
  createNumericRegex: function createNumericRegex(hasDecimal, hasSign) {
    var regexString = '^';

    if (hasSign) {
      regexString += '-?';
    }

    regexString += '(?:(?:\\d+';

    if (hasDecimal) {
      regexString += '(\\.\\d*)?';
    }

    regexString += ')|(?:\\.\\d*))?$';
    return new RegExp(regexString);
  }
};

var NumericTextboxComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumericTextboxComponent, _React$Component);

  function NumericTextboxComponent(props) {
    var _this;

    _classCallCheck(this, NumericTextboxComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumericTextboxComponent).call(this, props));
    _this.focused = false;
    _this.numericRegex = null;
    _this.numericInput = null;
    _this.value = _this.props.value;
    _this.state = {
      value: ''
    };
    return _this;
  }

  _createClass(NumericTextboxComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setInputValue();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.verifySettings();

      if (Helper.anyChanges(['autoCorrect', 'decimals'], prevProps, this.props)) {
        delete this.numericRegex;
      }

      if (Helper.anyChanges(['format'], prevProps, this.props)) {
        this.setInputValue();
      }

      if (!this.focused && Helper.anyChanges(['value'], prevProps, this.props)) {
        var _this$props = this.props,
            value = _this$props.value,
            autoCorrect = _this$props.autoCorrect;
        var newValue = this.restrictDecimals(value);

        if (autoCorrect && this.limitValue(newValue) !== newValue) {
          newValue = null;
        }

        this.value = newValue;
        this.setInputValue();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          disabled = _this$props2.disabled,
          className = _this$props2.className;
      var value = this.state.value;
      return _react.default.createElement("input", {
        ref: function ref(element) {
          return _this2.numericInput = element;
        },
        type: "text",
        inputMode: "decimal",
        className: className,
        value: value,
        placeholder: placeholder,
        disabled: disabled,
        onChange: function onChange() {
          return _this2.handleInput();
        },
        onBlur: function onBlur() {
          return _this2.handleBlur();
        },
        onFocus: function onFocus() {
          return _this2.handleFocus();
        },
        onKeyDown: function onKeyDown(event) {
          return _this2.handleKeyDown(event);
        }
      });
    }
  }, {
    key: "handleInput",
    value: function handleInput() {
      var _this$numericInput = this.numericInput,
          selectionStart = _this$numericInput.selectionStart,
          selectionEnd = _this$numericInput.selectionEnd,
          value = _this$numericInput.value;

      if (!this.isValidInput(value)) {
        this.setInputValue(this.value);
        this.setSelection(selectionStart - 1, selectionEnd - 1);
      } else {
        var orginalInputValue = this.parseNumber(value);
        var limitInputValue = this.restrictDecimals(orginalInputValue);
        var autoCorrect = this.props.autoCorrect;

        if (autoCorrect) {
          limitInputValue = this.limitValue(limitInputValue);
        }

        if (orginalInputValue !== limitInputValue) {
          this.setInputValue(limitInputValue);
          this.setSelection(selectionStart, selectionEnd);
        } else {
          this.setInputValue(value);
        }

        this.updateValue(limitInputValue);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      var _this3 = this;

      if (!this.focused) {
        this.focused = true;
        this.setInputValue();
        setTimeout(function () {
          var value = _this3.state.value;

          _this3.setSelection(0, value.length);
        });
      }

      var onFocus = this.props.onFocus;

      if (onFocus) {
        onFocus();
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      if (this.focused) {
        this.focused = false;
        this.setInputValue();
      }

      var onBlur = this.props.onBlur;

      if (onBlur) {
        onBlur();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          onEnter = _this$props3.onEnter,
          onEscape = _this$props3.onEscape;

      if (!disabled) {
        switch (event.which) {
          case keyCodes.down:
            this.addStep(-1);
            break;

          case keyCodes.up:
            this.addStep(1);
            break;

          case keyCodes.enter:
            if (onEnter) {
              onEnter();
            }

            break;

          case keyCodes.escape:
            if (onEscape) {
              onEscape();
            }

            break;
        }
      }
    }
  }, {
    key: "verifySettings",
    value: function verifySettings() {
      var _this$props4 = this.props,
          min = _this$props4.min,
          max = _this$props4.max,
          decimals = _this$props4.decimals,
          value = _this$props4.value;

      if (value && !(0, _lodash.isNumber)(value)) {
        throw new Error('The value is not a valid number');
      }

      if ((0, _lodash.isNumber)(min) && (0, _lodash.isNumber)(max) && min > max) {
        throw new Error('The max value should be bigger than the min value');
      }

      if ((0, _lodash.isNumber)(decimals) && decimals < 0) {
        throw new Error('The decimals value should be bigger than 0');
      }
    }
  }, {
    key: "isValidInput",
    value: function isValidInput(input) {
      var numericRegex = this.numericRegex;

      if ((0, _lodash.isNil)(numericRegex)) {
        var _this$props5 = this.props,
            min = _this$props5.min,
            decimals = _this$props5.decimals,
            autoCorrect = _this$props5.autoCorrect;
        var hasDecimal = true;

        if ((0, _lodash.isNumber)(decimals) && decimals === 0) {
          hasDecimal = false;
        }

        var hasSign = true;

        if ((0, _lodash.isNumber)(min) && min >= 0 && autoCorrect) {
          hasSign = false;
        }

        numericRegex = Helper.createNumericRegex(hasDecimal, hasSign);
      }

      return numericRegex.test(input);
    }
  }, {
    key: "parseNumber",
    value: function parseNumber(input) {
      return (0, _numeral.default)(input).value();
    }
  }, {
    key: "addStep",
    value: function addStep(step) {
      var value = this.value ? step + this.value : step;
      value = this.limitValue(value);
      value = this.restrictDecimals(value);
      this.setInputValue(value);
      this.updateValue(value);
    }
  }, {
    key: "restrictDecimals",
    value: function restrictDecimals(value) {
      var decimals = this.props.decimals;

      if ((0, _lodash.isNumber)(decimals)) {
        var words = String(value).split('.');

        if (words.length === 2) {
          var decimalPart = words[1];

          if (decimalPart.length > decimals) {
            value = parseFloat(words[0] + '.' + decimalPart.substr(0, decimals));
          }
        }
      }

      return value;
    }
  }, {
    key: "limitValue",
    value: function limitValue(value) {
      var _this$props6 = this.props,
          min = _this$props6.min,
          max = _this$props6.max;

      if ((0, _lodash.isNumber)(max) && value > max) {
        return max;
      }

      if ((0, _lodash.isNumber)(min) && value < min) {
        return min;
      }

      return value;
    }
  }, {
    key: "setInputValue",
    value: function setInputValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if ((0, _lodash.isNil)(value)) {
        value = this.value;
      }

      var inputValue = this.formatValue(value);

      if (inputValue !== this.state.value) {
        this.setState({
          value: inputValue
        });
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      if (this.value !== value) {
        this.previousValue = this.value;
        this.value = value;
        var onChange = this.props.onChange;

        if (onChange) {
          onChange(value);
        }
      }
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      if (!(0, _lodash.isNil)(value)) {
        if (this.focused) {
          return this.formatInputValue(value);
        } else {
          return this.formatNumber(value);
        }
      }

      return '';
    }
  }, {
    key: "formatInputValue",
    value: function formatInputValue(value) {
      return String(value);
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(value) {
      var format = this.props.format;

      if (format) {
        return (0, _numeral.default)(value).format(format);
      } else {
        return (0, _lodash.toString)(value);
      }
    }
  }, {
    key: "setSelection",
    value: function setSelection(start, end) {
      //this.numericInput.setSelectionRange(start, end);
    }
  }]);

  return NumericTextboxComponent;
}(_react.default.Component);

NumericTextboxComponent.propTypes = propTypes;
NumericTextboxComponent.defaultProps = defaultProps;
var _default = NumericTextboxComponent;
exports.default = _default;